function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useCaseMixin } from '@/apps/attributes/mixins/use_case_mixin';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import tasks from '@/js/tasks';
export default {
  name: 'EditUsersComponent',
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  mixins: [useCaseMixin],
  data: function data() {
    return {
      newUsers: [],
      usersList: [],
      messages: [],
      hasBusinessUserSA: false,
      pagination: {
        current: 1,
        limit: 5,
        total: 0
      },
      keyTable: 0
    };
  },
  created: function created() {
    var _this = this;
    this.getUseCase().then(function () {
      _this.usersList = _this.getUsersList();
      _this.getBusinessAreas();
      if (_this.businessUserServiceAccounts.length) {
        _this.service_account = _this.getBusinessArea;
        _this.messages.push(_this.translate('frases.attributes_only_one_sa'));
        _this.hasBusinessUserSA = true;
      }
    });
  },
  methods: {
    getUsersList: function getUsersList() {
      var users = [];
      if (this.useCase.env_user_group) {
        var usersMetadata = this.useCase.env_user_group.email || [];
        users = Object.values(usersMetadata).map(function (user) {
          return {
            email: user
          };
        });
      }
      return users;
    },
    resetForm: function resetForm() {
      this.newUsers = [];
      this.$refs.form.resetValidation();
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    onSubmit: function onSubmit(event) {
      var _this2 = this;
      event.preventDefault();
      if (!this.validate() || this.errors.length > 0) {
        return;
      }
      var totalUsers = [].concat(_toConsumableArray(this.users), _toConsumableArray(this.newUsers));
      totalUsers = _toConsumableArray(new Set(totalUsers));
      var envUserGroup = {
        email: {}
      };
      totalUsers.forEach(function (item, index) {
        envUserGroup['email'][index.toString()] = item;
      });
      var params = {
        env_user_group: envUserGroup
      };
      UseCasesService.updateUsersUseCase(this.useCase.company_code, this.useCase.id, params).then(function (response) {
        _this2.getUseCase().then(function () {
          _this2.resetForm();
          _this2.usersList = _this2.getUsersList();
          _this2.keyTable = _this2.keyTable + 1;
        });
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
      });
    },
    onRevokeUser: function onRevokeUser(item) {
      var _this3 = this;
      var params = {
        env_user_group: {
          email: {
            0: item.email
          }
        }
      };
      UseCasesService.revokeUsersUseCase(this.useCase.company_code, this.useCase.id, params).then(function (response) {
        console.log(response);
        _this3.getUseCase().then(function () {
          _this3.usersList = _this3.getUsersList();
          _this3.keyTable = _this3.keyTable + 1;
        });
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this3.translate('error_messages.error_general'), _this3.translate('titles.error'));
      });
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: 'User',
        value: 'email'
      }, {
        text: 'Actions',
        value: 'actions'
      }];
    },
    rules: function rules() {
      var _this4 = this;
      return {
        users: [this.ruleEmailMultiSelect],
        serviceAccount: [function (v) {
          return !!v || _this4.translate('reglas.field');
        }]
      };
    },
    isUserOwner: function isUserOwner() {
      var _this5 = this;
      return function (item) {
        return item.email === _this5.useCase.owner_name;
      };
    },
    isServiceAccount: function isServiceAccount() {
      var _this6 = this;
      return function (item) {
        var result = _this6.businessUserServiceAccounts.some(function (x) {
          return x.email.includes(item.email);
        });
        return result;
      };
    }
  }
};